











































































































































import { Component, Mixins } from "vue-property-decorator";
import { AuthModule } from "@/store/auth.module";
import { DialogsModule } from "@/store/dialogs.module";
import { mdiPencil } from "@mdi/js";
import FormValidator from "@/mixins/FormValidator";
import { EmailService } from "@/services/api/email.service";
import SvgIcon from "@/components/ui/SvgIcon.vue";

@Component({
  components: {
    SvgIcon,
  },
})
export default class OrganizationPage extends Mixins(FormValidator) {
  $refs: {
    emailRef: any;
  };
  formRef = "emailRef";
  showDialog: boolean = false;

  get isAvailable() {
    return AuthModule.isEmailMutationAvailable;
  }

  passwordSetted: boolean = false;
  async setPassword() {
    try {
      this.passwordSetted = true;
      await AuthModule.setPassword();
      this.showDialog = true;
    } finally {
      this.passwordSetted = false;
    }
  }

  mdiPencil = mdiPencil;
  get user() {
    return AuthModule.user as IUser;
  }

  openDialog() {
    DialogsModule.setEmailConfirmationDialog({
      show: true,
      isSent: false,
    });
  }
  email = "";
  emailEditMode = false;
  created() {
    this.clearEmail();
  }

  async updateEmail() {
    this.emailEditMode = false;

    if (!this.$refs.emailRef.validate()) return;
    if (this.email == this.user?.email) return;

    const { result, message } = await EmailService.changeEmail(this.email);
    if (!result) {
      return DialogsModule.setEmailConfirmationDialog({
        show: true,
        isSent: true,
        text: message,
      });
    }
    AuthModule.setUser({
      ...this.user,
      email: this.email,
      org_data: {
        isEmailVerified: false,
      },
    });
    DialogsModule.setEmailConfirmationDialog({
      show: true,
      isSent: true,
    });
  }

  clearEmail() {
    this.email = this.user?.email || "";
  }

  cancelEmailEdit() {
    this.emailEditMode = false;
    this.clearEmail();
  }
  get canConfirmEmail() {
    return !this.user.org_data.isEmailVerified && this.user.email;
  }
  get canSetPass() {
    return this.user.org_data.isEmailVerified && this.user.email;
  }
  get canUpdPass() {
    return (
      this.user.pass_exists &&
      this.user.org_data.isEmailVerified &&
      this.user.email
    );
  }
}
